
<template>
    <div class="vheight overallEvaluation">
        <div class="container-boot">
            <div class="header-box">
                评分主题：{{detailObj.EvaluateObj}}
                <span>{{detailObj.EvaluateTime | getDate}}</span>
            </div>
            <ul>
                <li v-for="(item, index) of dataList" :key="index">
                    <div class="title-box">
                        <div class="box-left">
                            {{index + 1}}.{{item.OptionName}}
                        </div>
                        <div class="box-right">
                            <span v-if="item.Star >= 5">非常满意</span>
                            <span v-else-if="4 <= item.Star">比较满意</span>
                            <span v-else-if="3 <= item.Star">一般满意</span>
                            <span v-else-if="2 <= item.Star">不太满意</span>
                            <span v-else>非常不满意</span>
                            <span>分&nbsp;&nbsp;</span>
                            <el-rate
                            v-model="item.Star"
                            disabled
                            show-score
                            :colors="['#8c4f7f','#8c4f7f','#8c4f7f']"
                            disabled-void-color="#fff"
                            score-template="{value}">
                            </el-rate>
                        </div>
                    </div>
                    <div class="cont-box" v-show='item.Star < 4 && item.Star > 0' v-if="item.DiscontentItems && item.DiscontentItems._Items.length > 0">
                        <div class="term" v-for='(chlds,idx) in item.DiscontentItems._Items' :key='idx'>
                            <el-checkbox
                                v-if="chlds.isElse == false"
                                disabled
                                :label="chlds.DiscontentValue" 
                                v-model='chlds.KeyId' 
                                :checked='chlds.KeyId !== null'
                                false-label="null"
                                true-label="true"
                            >
                                {{chlds.DiscontentValue}}
                            </el-checkbox>
                            <div v-if="chlds.isElse == true">
                                {{chlds.DiscontentValue}}
                            </div>
                        </div>
                    </div>
                    <div class="cont-box" v-else>-</div>
                </li>
                <li>
                    <div class="title-box">
                        意见：
                    </div>
                    <div class="cont-box">
                        {{detailObj.Content || '-'}}
                    </div>
                </li>
            </ul>
            <div class="remark-box">
                <div class="remark-t">回复内容：<span>{{detailObj.PropertyReplyTime | getDate}}</span></div>
                <div class="remark-c">
                    {{detailObj.PropertyReply || '-'}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { Page } from '@/models/page';
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
export default {
    components: {
    },
    props: {},
    data() {
        return {
            loading: false,
            dataList:[],
            detailObj:{},
            keyId: '',
            evaluateObjType: 3,
            page: new Page(),
        };
    },
    computed: { ...mapState(['token', 'userInfo']) },
    filters:{
        getScore(score, num){
            if(score && num){
                return (score / num).toFixed(1)
            }else if(score == 0 && num > 0){
                return 0;
            }else{
                return '-'
            }
        },
        getDate(val){
            if(val){
                return val.replace('T',' ')
            }else{
                return '-'
            }
        }
    },
    created() {
        this.CreditInformationController = new CreditInformationController();
        this.keyId = this.$route.query.keyId || '';
        this.evaluateObjType = this.$route.query.evaluateObjType;
        this.getData();
    },
    methods: {
        getData(){
            this.CreditInformationController.GetEvaluateDetial(this.keyId).then(res=>{
                if(res){
                    this.detailObj = res;
                    if(res.Items && res.Items._Items) {
                        this.dataList = res.Items._Items;
                    }
                }
            }).catch(err=>{
                this.$message({
                    type:'error',
                    message:err
                })
            })
        },
    }
};
</script>
<style lang="scss">
.overallEvaluation {
    
}
</style>
<style lang="scss" scoped>
.overallEvaluation {
    width: 100%;
    box-sizing: border-box;
    .header-box{
        margin-top: 10px;
        line-height: 30px;
        margin-bottom: 15px;
        span{
            float: right;
        }
    }
    ul{
        li{
            margin-bottom: 15px;
            .title-box{
                display: flex;
                box-sizing: border-box;
                padding: 0px 10px;
                border-radius: 5px;
                background-color: #eee;
                line-height: 30px;
                .box-left{
                    width: 70%;
                }
                .box-right{
                    flex: 1;
                    text-align: right;
                    .el-rate{
                        float: right;
                        margin-top: 6px;
                    }
                    span{
                        float: right;
                    }
                }
            }
            .cont-box{
                margin-top: 10px;
                padding: 0 10px;
            }
        }
    }
    .remark-box{
        border-top: 1px solid #eee;
        box-sizing: border-box;
        padding-top: 20px;
        margin-top: 10px;
        .remark-t{
            line-height: 20px;
            span{
                float: right;
            }
        }
        .remark-c{
            line-height: 20px;
            margin-top: 10px;
            padding: 0 10px;
        }
    }
}
</style>